'use client';

import { API_ROUTES, HTTP_METHODS, useApiInvalidate, useApiMutation } from '@shared/api-utils';
import { createDebug } from '@shared/debug';

const debug = createDebug({ isEnabled: false });

/**
 * Hook that creates the three inbox mutations for the given message id.
 * @param id - message id
 * @returns the three inbox mutations
 */
function useInboxMessageMutations(id: string) {
  const { invalidateQuery } = useApiInvalidate();

  const openMessageMutation = useApiMutation<void>(API_ROUTES.MY_ACCOUNT.INBOX.OPEN.replace(':messageId', id), HTTP_METHODS.PATCH, {
    mutationOptions: {
      onError: error => {
        debug.forceError('Failed to track message opening:', error);
      },
    },
  });

  const markMessageAsReadMutation = useApiMutation<void>(API_ROUTES.MY_ACCOUNT.INBOX.READ.replace(':messageId', id), HTTP_METHODS.PATCH, {
    mutationOptions: {
      onSuccess: () => {
        invalidateQuery(API_ROUTES.MY_ACCOUNT.INBOX.MESSAGES);
      },
      onError: error => {
        debug.forceError('Failed to mark message as read:', error);
      },
    },
  });

  const clickMessageMutation = useApiMutation<void>(API_ROUTES.MY_ACCOUNT.INBOX.CLICK.replace(':messageId', id), HTTP_METHODS.PATCH, {
    mutationOptions: {
      onError: error => {
        debug.forceError('Failed to click message:', error);
      },
    },
  });
  return {
    openMessageMutation,
    markMessageAsReadMutation,
    clickMessageMutation,
  };
}

export { useInboxMessageMutations };
